module.exports = __webpack_public_path__ + "static/media/image 16.cbdf89d7.png";